// extracted by mini-css-extract-plugin
export default {"social-media-links":"L7hti9I","social-media-links__list":"ML05y3W","social-media-links__item":"eFXVcmn"};